export const NOTIFICATION_CONFIG = {
  PLACEMENT: 'bottomLeft' as const,
  DURATION: {
    SUCCESS: 3,
    ERROR: 5,
  },
} as const;
